import { render, staticRenderFns } from "./Spagination.vue?vue&type=template&id=07fe5214&"
import script from "./Spagination.vue?vue&type=script&lang=js&"
export * from "./Spagination.vue?vue&type=script&lang=js&"
import style0 from "./Spagination.vue?vue&type=style&index=0&id=07fe5214&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports